import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import CustomDataTableEditable from "../../../../partials/content/CustomDataTableEditable";
import { getItemsMasterData } from "../../../../services/inventory/itemService";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";
import Illustration from "../../../../partials/content/Illustration";
import NumberFormat from "react-number-format";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function ConfirmUploadedItems() {
  const { values, handleSubmit } = useFormikContext();
  const [auth, setAuth] = useState({});
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  const [uomOptions, setUomOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [itemCategoryOptions, setItemCategoryOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const { companyProfile } = useGlobalData();

  useEffect(() => {
    function getItemMasterData() {
      getItemsMasterData().then((response) => {
        const { data, auth } = response.data;
        const { brands, categories, uoms, variants } = data.itemsMasterData;
        setMasterData(brands, categories, uoms, variants);
        setAuth(auth);
        setCategories(categories);
      });
    }
    getItemMasterData();
  }, []);
  return (
    <>
      {values.length > 0 ? (
        <CustomDataTableEditable
          data={values}
          buttons={[
            {
              name: "Upload",
              onClick: (e) => {
                handleSubmit(e);
              },
              icon: "fas fa-upload",
              color: "success",
            },
          ]}
          onRowEditComplete={(e) => {
            let { newData, index } = e;
            values[index] = newData;

            /*Update selected dropdown label*/
            const itemTypeName = itemTypeOptions.filter(function(dropdown) {
              return dropdown.value === values[index].itemType;
            });
            if (itemTypeName.length > 0) {
              values[index].itemTypeName = itemTypeName[0].label;
            } else {
              values[index].itemType = 0;
              values[index].itemTypeName = "";
            }

            const uomName = uomOptions.filter(function(dropdown) {
              return dropdown.value === values[index].uomID;
            });
            if (uomName.length > 0) {
              values[index].uomName = uomName[0].label;
            } else {
              values[index].uomID = 0;
              values[index].uomName = "";
            }

            const brandName = brandOptions.filter(function(dropdown) {
              return dropdown.value === values[index].brandID;
            });
            if (brandName.length > 0) {
              values[index].brandName = brandName[0].label;
            } else {
              values[index].brandID = 0;
              values[index].brandName = "";
            }

            const categoryName = categoryOptions.filter(function(dropdown) {
              return dropdown.value === values[index].categoryID;
            });
            if (categoryName.length > 0) {
              values[index].categoryName = categoryName[0].label;
            } else {
              values[index].categoryID = 0;
              values[index].categoryName = "";
            }

            const subCategoryName = subCategoryOptions.filter(function(
              dropdown
            ) {
              return dropdown.value === values[index].subCategoryID;
            });
            if (subCategoryName.length > 0) {
              if (
                typeof categories !== "undefined" &&
                categoryName.length > 0
              ) {
                const categoryTmp = categories.filter(function(category) {
                  return category.ID === categoryName[0].value;
                });
                if (categoryTmp.length > 0 && subCategoryName.length > 0) {
                  const subCategoryTmp = categoryTmp[0].subCategory.filter(
                    function(subCategory) {
                      return subCategory.ID === subCategoryName[0].value;
                    }
                  );
                  if (subCategoryTmp.length > 0) {
                    values[index].subCategoryID = subCategoryName[0].value;
                    values[index].subCategoryName = subCategoryName[0].label;
                  } else {
                    values[index].subCategoryID = 0;
                    values[index].subCategoryName = subCategoryName[0].label;
                  }
                } else {
                  values[index].subCategoryID = 0;
                  values[index].subCategoryName = subCategoryName[0].label;
                }
              } else {
                values[index].subCategoryID = 0;
                values[index].subCategoryName = subCategoryName[0].label;
              }
            } else {
              values[index].subCategoryID = 0;
              values[index].subCategoryName = "";
            }

            const itemCategoryName = itemCategoryOptions.filter(function(
              dropdown
            ) {
              return dropdown.value === values[index].itemCategoryID;
            });
            if (itemCategoryName.length > 0) {
              if (
                typeof categories !== "undefined" &&
                categoryName.length > 0
              ) {
                const categoryTmp = categories.filter(function(category) {
                  return category.ID === categoryName[0].value;
                });
                if (categoryTmp.length > 0 && subCategoryName.length > 0) {
                  const subCategoryTmp = categoryTmp[0].subCategory.filter(
                    function(subCategory) {
                      return subCategory.ID === subCategoryName[0].value;
                    }
                  );
                  if (
                    subCategoryTmp.length > 0 &&
                    itemCategoryName.length > 0
                  ) {
                    const itemCategoryTmp = subCategoryTmp[0].itemCategory.filter(
                      function(itemCategory) {
                        return itemCategory.ID === itemCategoryName[0].value;
                      }
                    );
                    if (itemCategoryTmp.length > 0) {
                      values[index].itemCategoryID = itemCategoryName[0].value;
                      values[index].itemCategoryName =
                        itemCategoryName[0].label;
                    } else {
                      values[index].itemCategoryID = 0;
                      values[index].itemCategoryName =
                        itemCategoryName[0].label;
                    }
                  } else {
                    values[index].itemCategoryID = 0;
                    values[index].itemCategoryName = itemCategoryName[0].label;
                  }
                } else {
                  values[index].itemCategoryID = 0;
                  values[index].itemCategoryName = itemCategoryName[0].label;
                }
              } else {
                values[index].itemCategoryID = 0;
                values[index].itemCategoryName = itemCategoryName[0].label;
              }
            } else {
              values[index].itemCategoryID = 0;
              values[index].itemCategoryName = "";
            }

            /*Update mass upload status ID*/
            values[index].statusID = 1;

            if (
              values[index].itemType === 0 &&
              values[index].itemTypeName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (values[index].itemCode === "") {
              values[index].statusID = 0;
            }
            if (values[index].itemName === "") {
              values[index].statusID = 0;
            }
            if (values[index].uomID === 0 && values[index].uomName !== "") {
              values[index].statusID = 0;
            }
            if (values[index].brandID === 0 && values[index].brandName !== "") {
              values[index].statusID = 0;
            }
            if (
              values[index].categoryID === 0 &&
              values[index].categoryName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (
              values[index].subCategoryID === 0 &&
              values[index].subCategoryName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (
              values[index].itemCategoryID === 0 &&
              values[index].itemCategoryName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (values[index].cogsUnit === "") {
              values[index].statusID = 0;
            }
            if (values[index].marginAmount === "") {
              values[index].statusID = 0;
            }
          }}
          columns={[
            {
              header: "Mass Upload Status",
              field: "statusID",
              body: (rowData) => {
                if (rowData.statusID === 0) {
                  return <Badge variant="danger">Not Ready To Upload</Badge>;
                } else if (rowData.statusID === 1) {
                  return <Badge variant="success">Ready To Upload</Badge>;
                } else if (rowData.statusID === 2) {
                  return <Badge variant="primary">Successfully Uploaded</Badge>;
                } else if (rowData.statusID === 3) {
                  return (
                    <React.Fragment>
                      <span className="mr-3">
                        <BootstrapTooltip title={rowData.message}>
                          <span className="mr-1">
                            <i className="fas fa-exclamation-triangle kt-font-warning"></i>
                          </span>
                        </BootstrapTooltip>
                        <Badge variant="danger">Unsuccessfully Uploaded</Badge>
                      </span>
                    </React.Fragment>
                  );
                }
              },
              sortable: true,
              filter: true,
            },
            {
              header: "Item Type",
              field: "itemType",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.itemType === 0 && rowData.itemTypeName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Item Type is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.itemTypeName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.itemType === 0 &&
                      rowData.itemTypeName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Item Type is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.itemTypeName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.itemType > 0 ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.itemTypeName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: itemTypeOptions,
            },
            {
              header: "Item Code",
              field: "itemCode",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.itemCode === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Item Code is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.itemCode}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.itemCode !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.itemCode}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Item Name",
              field: "itemName",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.itemName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Item Name is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.itemName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.itemName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.itemName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Base Unit of Measurement",
              field: "uomID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.uomID === 0 && rowData.uomName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Base Unit of Measurement is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.uomName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.uomID === 0 && rowData.uomName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Base Unit of Measurement is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.uomName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.uomID > 0 ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.uomName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: uomOptions,
            },
            {
              header: "Universal Product Code",
              field: "upc",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    <span className="mr-3">
                      <BootstrapTooltip title="The data is acceptable">
                        <span className="mr-1">
                          <i className="fas fa-check-circle kt-font-success"></i>
                        </span>
                      </BootstrapTooltip>
                      <span className="mr-1">{rowData.upc}</span>
                    </span>
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Brand",
              field: "brandID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.brandID === 0 && rowData.brandName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Brand is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.brandName}</span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.brandName}</span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: brandOptions,
            },
            {
              header: "Category",
              field: "categoryID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.categoryID === 0 && rowData.categoryName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Category is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.categoryName}</span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.categoryName}</span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: categoryOptions,
            },
            {
              header: "Sub Category",
              field: "subCategoryID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.subCategoryID === 0 &&
                    rowData.subCategoryName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Sub Category is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.subCategoryName}
                          </span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.subCategoryName}
                          </span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: subCategoryOptions,
            },
            {
              header: "Item Category",
              field: "itemCategoryID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.itemCategoryID === 0 &&
                    rowData.itemCategoryName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Item Category is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.itemCategoryName}
                          </span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.itemCategoryName}
                          </span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: itemCategoryOptions,
            },
            {
              header: "Cost Of Goods Sold",
              field: "cogsUnit",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.cogsUnit === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Cost Of Goods Sold is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            <NumberFormat
                              value={rowData.cogsUnit}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                              renderText={(value) => (
                                <div className="float-right">
                                  {companyProfile.currency.currencyCode} {value}
                                </div>
                              )}
                            />
                          </span>
                        </span>
                      </React.Fragment>
                    ) : rowData.cogsUnit !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            <NumberFormat
                              value={rowData.cogsUnit}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                              renderText={(value) => (
                                <div className="float-right">
                                  {companyProfile.currency.currencyCode} {value}
                                </div>
                              )}
                            />
                          </span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "currency",
            },
            {
              header: "Margin Amount",
              field: "marginAmount",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.marginAmount === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Margin Amount is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            <NumberFormat
                              value={rowData.marginAmount}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                              renderText={(value) => (
                                <div className="float-right">
                                  {companyProfile.currency.currencyCode} {value}
                                </div>
                              )}
                            />
                          </span>
                        </span>
                      </React.Fragment>
                    ) : rowData.marginAmount !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            <NumberFormat
                              value={rowData.marginAmount}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                              renderText={(value) => (
                                <div className="float-right">
                                  {companyProfile.currency.currencyCode} {value}
                                </div>
                              )}
                            />
                          </span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "currency",
            },
            {
              header: "Item Description",
              field: "itemDesc",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    <span className="mr-3">
                      <BootstrapTooltip title="The data is acceptable">
                        <span className="mr-1">
                          <i className="fas fa-check-circle kt-font-success"></i>
                        </span>
                      </BootstrapTooltip>
                      <span className="mr-1">{rowData.itemDesc}</span>
                    </span>
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
          ]}
        />
      ) : (
        <Illustration
          imageSource="INVIFO Setup.png"
          description="Good Start! You're ready for Mass Upload!"
          guidance="Hint: upload master data based on template provided"
          descriptionLeftIcon="fas fa-info-circle kt-font-success"
        ></Illustration>
      )}
    </>
  );
  function setMasterData(
    brands = [],
    categories = [],
    uoms = [],
    variants = []
  ) {
    let itemTypeOptionsTmp = [];
    let brandOptionsTmp = [];
    let categoryOptionsTmp = [];
    let subCategoryOptionsTmp = [];
    let itemCategoryOptionsTmp = [];
    let uomOptionsTmp = [];
    let variantOptionsTmp = [];

    itemTypeOptionsTmp.push({
      value: 1,
      label: "Finished Product",
    });
    itemTypeOptionsTmp.push({
      value: 2,
      label: "Service",
    });
    itemTypeOptionsTmp.push({
      value: 3,
      label: "Asset",
    });
    itemTypeOptionsTmp.push({
      value: 4,
      label: "Semi-Finished Product",
    });
    itemTypeOptionsTmp.push({
      value: 5,
      label: "Raw Material",
    });

    if (typeof brands !== "undefined") {
      brands.forEach((brand) => {
        brandOptionsTmp.push({
          value: brand.ID,
          label: brand.brandName,
        });
      });
    }

    if (typeof categories !== "undefined") {
      categories.forEach((category) => {
        categoryOptionsTmp.push({
          value: category.ID,
          label: category.categoryName,
        });
        if (typeof category.subCategory !== "undefined") {
          category.subCategory.forEach((subCategory) => {
            subCategoryOptionsTmp.push({
              value: subCategory.ID,
              label: subCategory.subCategoryName,
            });
            if (typeof subCategory.itemCategory !== "undefined") {
              subCategory.itemCategory.forEach((itemCategory) => {
                itemCategoryOptionsTmp.push({
                  value: itemCategory.ID,
                  label: itemCategory.itemCategoryName,
                });
              });
            }
          });
        }
      });
    }

    if (typeof uoms !== "undefined") {
      uoms.forEach((uom) => {
        uomOptionsTmp.push({
          value: uom.ID,
          label: uom.uomName,
        });
      });
    }

    if (typeof variants !== "undefined") {
      variants.forEach((variant) => {
        variantOptionsTmp.push({
          value: variant.ID,
          label: variant.variantName,
        });
      });
    }

    setItemTypeOptions(itemTypeOptionsTmp);
    setUomOptions(uomOptionsTmp);
    setBrandOptions(brandOptionsTmp);
    setCategoryOptions(categoryOptionsTmp);
    setSubCategoryOptions(subCategoryOptionsTmp);
    setItemCategoryOptions(itemCategoryOptionsTmp);
    setVariantOptions(variantOptionsTmp);
  }
}

export default ConfirmUploadedItems;
